import type { ReactNode } from 'react';
import { fieldTypeOf, settingsOf } from '../field-types';
import type { FillInputProps, FillLabel } from '../field-types/fillInput';
import type { FieldElement } from '../format/form-definition';
import { FieldTypeCard } from '../field-types/card';

interface FieldInput {
  settings: object;
  Input: (props: FillInputProps<unknown, object>) => ReactNode;
  labelKind: FillLabel;
  emptyValue: unknown;
  card: FieldTypeCard;
}

export const fieldInputOf = (field: FieldElement): FieldInput => {
  const card = fieldTypeOf(field);
  const settings = settingsOf(field);
  return {
    card,
    settings,
    Input: card.FillInput,
    labelKind: card.fillLabel?.(settings) ?? 'outlined',
    emptyValue: card.emptyValue,
  };
};
